import React, { useEffect } from "react";
import NotificationRow from "./NotificationRow";
import config from "@frameworks/salesjourney/config/domain";
import { EnumSalesFilter, } from "@domains/salesFeatures/Common/entities/IFilterDataEntity";
import Loader from "../../../../shared-library/components/Loader";
var NotificationPopup = function (props) {
    var _a, _b, _c, _d, _e;
    var routeLeadDashboard = function () {
        props === null || props === void 0 ? void 0 : props.setNotifyPopup(false);
        if (Number(props === null || props === void 0 ? void 0 : props.expiringLeads) > 0) {
            return (config.applicationFolder +
                "dashboard/lead-dashboard?isExpiry=" +
                true +
                "&tabFlag=" +
                2);
        }
    };
    var followupLinkRef = function (dealerEmpCode, name) {
        var filterData = {
            teamType: [1, 2],
            teamTypeLst: [
                {
                    id: 1,
                    parentFilter: EnumSalesFilter.teamType,
                    checked: true,
                    inputType: "checkbox",
                    filterKey: EnumSalesFilter.teamTypeLst,
                    name: "Self",
                },
                {
                    id: 2,
                    parentFilter: EnumSalesFilter.teamType,
                    checked: true,
                    inputType: "checkbox",
                    filterKey: EnumSalesFilter.teamTypeLst,
                    name: "Team",
                },
            ],
            rmId: [dealerEmpCode],
            rmIdLst: [
                {
                    id: dealerEmpCode,
                    parentFilter: EnumSalesFilter.rmId,
                    checked: true,
                    inputType: "checkbox",
                    filterKey: EnumSalesFilter.rmIdLst,
                    name: name,
                },
            ],
            isfollowupAging: true,
        };
        props === null || props === void 0 ? void 0 : props.setNotifyPopup(false);
        return (config.applicationFolder +
            "dashboard/lead-dashboard?filterData=" +
            encodeURI(JSON.stringify(filterData)) +
            "&tabFlag=" +
            0);
    };
    var criticalPriorityLinkRef = function (criticalAgeingData) {
        var leadIds = "";
        var rmIds = [];
        var rmIdsLst = [];
        if (criticalAgeingData) {
            leadIds = criticalAgeingData
                .map(function (obj) {
                rmIds.push(obj === null || obj === void 0 ? void 0 : obj.dealerEmpCode);
                rmIdsLst.push({
                    id: obj === null || obj === void 0 ? void 0 : obj.dealerEmpCode,
                    parentFilter: EnumSalesFilter.rmId,
                    checked: true,
                    inputType: "checkbox",
                    filterKey: EnumSalesFilter.rmIdLst,
                    name: obj === null || obj === void 0 ? void 0 : obj.name,
                });
                return obj === null || obj === void 0 ? void 0 : obj.leadId;
            })
                .join(",");
        }
        var filterData = {
            teamType: [2],
            showAllOpenLeads: true,
            teamTypeLst: [
                {
                    id: 2,
                    parentFilter: EnumSalesFilter.teamType,
                    checked: true,
                    inputType: "checkbox",
                    filterKey: EnumSalesFilter.teamTypeLst,
                    name: "Team",
                },
            ],
            leadId: leadIds,
            rmId: rmIds,
            rmIdLst: rmIdsLst,
        };
        props === null || props === void 0 ? void 0 : props.setNotifyPopup(false);
        return (config.applicationFolder +
            "dashboard/lead-dashboard?filterData=" +
            encodeURI(JSON.stringify(filterData)) +
            "&tabFlag=" +
            0);
    };
    var remappingCountRef = function () {
        var filterData = {
            remap: true,
            showAllOpenLeads: false,
        };
        return (config.applicationFolder +
            "dashboard/lead-dashboard?filterData=" +
            encodeURI(JSON.stringify(filterData)) +
            "&isDateSkip=" +
            true);
    };
    var viewPipelineAgingLeads = function () {
        var finalFilterList = {
            dcf: true,
        };
        return (config.applicationFolder +
            "dashboard/lead-dashboard?filterData=" +
            encodeURI(JSON.stringify(finalFilterList)) +
            "&isDateSkip=" +
            true);
    };
    var criticalLeadsCountRef = function () {
        var filterData = {
            icf: true,
            showAllOpenLeads: false,
        };
        return (config.applicationFolder +
            "dashboard/lead-dashboard?filterData=" +
            encodeURI(JSON.stringify(filterData)) +
            "&tabFlag=" +
            2 +
            "&isDateSkip=" +
            true);
    };
    useEffect(function () {
        props === null || props === void 0 ? void 0 : props.getAllNotifications();
    }, []);
    var getBoldText = function (text) {
        return React.createElement("span", { className: "DMSanM_14_500" }, text);
    };
    var generateNotificationText = function (notificationText1, notificationText2) {
        return (React.createElement("span", null,
            notificationText1,
            " ",
            notificationText2));
    };
    return (React.createElement("div", { className: "notification-popup" },
        (props === null || props === void 0 ? void 0 : props.loader) && React.createElement(Loader, null),
        React.createElement("div", { className: "d-flex justify-content-between notification-header px-3 py-2" },
            React.createElement("span", { className: "DMSan_16_700 txt_blackOne1 ps-3" }, "Notification")),
        React.createElement(NotificationRow, { notificationText: generateNotificationText("You have", getBoldText("".concat(props.expiringLeads, " Expiring Leads"))), icon: "edel-icon-target", linkHref: routeLeadDashboard(), disabled: !((props === null || props === void 0 ? void 0 : props.expiringLeads) > 0) }),
        ((_b = (_a = props === null || props === void 0 ? void 0 : props.criticalPriorityAging) === null || _a === void 0 ? void 0 : _a.criticalPriorityAgingData) === null || _b === void 0 ? void 0 : _b.length) > 0 && (React.createElement(NotificationRow, { notificationText: generateNotificationText(getBoldText("".concat((_c = props === null || props === void 0 ? void 0 : props.criticalPriorityAging) === null || _c === void 0 ? void 0 : _c.totalItems, " Critical Leads")), "ageing warning for RMs"), icon: "edel-icon-document", linkHref: criticalPriorityLinkRef((_d = props === null || props === void 0 ? void 0 : props.criticalPriorityAging) === null || _d === void 0 ? void 0 : _d.criticalPriorityAgingData), isCriticalPriorityAging: true })), (_e = props === null || props === void 0 ? void 0 : props.folloupAgeingData) === null || _e === void 0 ? void 0 :
        _e.map(function (obj) {
            return (React.createElement(NotificationRow, { notificationText: generateNotificationText(getBoldText("".concat(obj === null || obj === void 0 ? void 0 : obj.totalcount, " Leads")), "have been marked followup for 3+ times by ".concat(obj === null || obj === void 0 ? void 0 : obj.name)), icon: "edel-icon-calender-2", linkHref: followupLinkRef(obj === null || obj === void 0 ? void 0 : obj.dealerEmpCode, obj === null || obj === void 0 ? void 0 : obj.name) }));
        }),
        (props === null || props === void 0 ? void 0 : props.criticalLeadsCount) > 0 && (React.createElement(NotificationRow, { notificationText: generateNotificationText(getBoldText("".concat(props === null || props === void 0 ? void 0 : props.criticalLeadsCount, " Critical Leads")), "are lying open without any action, do you wish to update them?"), icon: "edel-icon-target", linkHref: criticalLeadsCountRef() })),
        (props === null || props === void 0 ? void 0 : props.pipelineAgingLeadCount) > 0 && (React.createElement(NotificationRow, { notificationText: generateNotificationText(getBoldText("".concat(props === null || props === void 0 ? void 0 : props.pipelineAgingLeadCount, " HOT Lead's")), "pipeline have not been changed since last 30 days"), icon: "edel-icon-calender-2", linkHref: viewPipelineAgingLeads() })),
        (props === null || props === void 0 ? void 0 : props.remappingCount) > 0 && (React.createElement(NotificationRow, { notificationText: "".concat(props === null || props === void 0 ? void 0 : props.remappingCount, " Remapping leads have been created."), icon: "edel-icon-calender-2", linkHref: remappingCountRef() }))));
};
export default NotificationPopup;
